module.exports = __webpack_public_path__ + "static/media/github.b012fd96.png";